import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditProducts = () => {
  const navigate = useNavigate();
  const { product_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [products, setProducts] = useState({
    product_code: "",
    product_name: "",
    batch_no: "",
    unit: "",
    box_content: "",
    rate_per: "",
    //stock: "",
    tax: "",
    supplier_id: "",
    brand_id: "",
    unit_id: "",
    supplier_name: "",

  });

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  // const [selectedBrand, setSelectedBrand] = useState("");
  const [supplier, setSupplier] = useState([]);
  const [selectedsupplier, setSelectedSupplier] = useState("");
  const [brand, setBrand] = useState([]);
  const [selectedbrand, setSelectedBrand] = useState("");
  const [unit, setUnit] = useState([]);
  const [selectedunit, setSelectedUnit] = useState("");


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}product_detail.php`,
          { product_id }
        );

        if (response.data && response.data.body) {
          const productData = response.data.body;
          setProducts(productData);
          setSelectedCategory(productData.category_id);
          setSelectedBrand(productData.brand_id);
          setSelectedUnit(productData.unit_id);
          setSelectedSupplier(productData.supplier_id);
        } else {
          setError("No data found");
        }
      } catch (error) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();

    axios
      .post(`${API_BASE_URL}category_list.php`)
      .then((res) => setCategories(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
    axios
      .post(`${API_BASE_URL}supplier_list.php`)
      .then((res) => setSupplier(res.data.body || []))
      .catch((err) => console.error("Category fetch error:", err));
    axios
      .post(`${API_BASE_URL}brand_list.php`)
      .then((res) => setBrand(res.data.body || []))
      .catch((err) => console.error("Brand fetch error:", err));
    axios
      .post(`${API_BASE_URL}unit_list.php`)
      .then((res) => setUnit(res.data.body || []))
      .catch((err) => console.error("Unit fetch error:", err));
  }, [product_id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProducts((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        `${API_BASE_URL}product_detail_update.php`,
        { product_id, ...products }
      );

      if (response.data.head.code === 200) {
        alert("Product updated successfully!");
        navigate("/products");
      } else {
        alert("Update failed: " + response.data.head.msg);
      }
    } catch (error) {
      alert("Failed to update product.");
    }
  };

  if (loading) return <p> </p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <>
      <Header />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="title-header option-title d-sm-flex d-block">
                        <h5>Edit Product</h5>
                        <div className="right-options">
                          <ul>
                            <li>
                              <Link
                                className="btn btn-solid"
                                onClick={() => window.history.back()}
                              >
                                Back
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <form className="theme-form theme-form-2 mega-form" onSubmit={handleUpdate}>
                        <div className="row">
                          {/* Product Name */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Product Name</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="product_name"
                                placeholder="Enter Product Name"
                                value={products.product_name || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                          {/* First row with four columns */}
                          <div className="col-md-4 col-sm-6 mb-4">
                            <label className="form-label-title">Supplier Name</label>
                            <select
                              className="form-control"
                              name="supplier_id"
                              value={selectedsupplier} // Ensure correct binding
                              onChange={(e) => {
                                const selectedId = e.target.value;

                                // Find the supplier object using supplier_id
                                const selectedSupplier = supplier.find((sup) => String(sup.id) === String(selectedId));

                                if (selectedSupplier) {
                                  setSelectedSupplier(selectedSupplier.supplier_id); // ✅ Store correct supplier_id
                                  setProducts((prev) => ({
                                    ...prev,
                                    supplier_id: selectedSupplier.id, // ✅ Ensure supplier_id is stored correctly
                                    supplier_name: selectedSupplier.supplier_name, // ✅ Dynamically store supplier_name
                                  }));
                                }
                              }}
                              // required
                            >
                              <option value="">Select Supplier</option>
                              {supplier.map((sup) => (
                                <option key={sup.id} value={sup.id}>
                                  {sup.supplier_name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Batch No</label>
                              <input
                                // required
                                className="form-control"
                                type="text"
                                name="batch_no"
                                placeholder="Enter Batch No"
                                value={products.batch_no || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {/* Product Name */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Serial No</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="serial_no"
                                placeholder="Enter Serial No"
                                value={products.serial_no || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                          {/* Brand */}
                          {/* <div className="col-md-3">
                            <div className="mb-4">
                              <label>Brand</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="brand"
                                placeholder="Enter Brand"
                                value={products.brand || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div> */}
                          <div className="col-md-4 col-sm-6 mb-4">
                            <label className="form-label-title">Brand Name</label>
                            <select
                              className="form-control"
                              name="brand_id"
                              value={selectedbrand} // Ensure correct binding
                              onChange={(e) => {
                                const selectedId = e.target.value;

                                // Find the supplier object using supplier_id
                                const selectedBrand = brand.find((brand) => String(brand.brand_id) === String(selectedId));

                                if (selectedBrand) {
                                  setSelectedBrand(selectedBrand.brand_id); // ✅ Store correct supplier_id
                                  setProducts((prev) => ({
                                    ...prev,
                                    brand_id: selectedBrand.brand_id, // ✅ Ensure supplier_id is stored correctly
                                    brand_name: selectedBrand.brand_name, // ✅ Dynamically store supplier_name
                                  }));
                                }
                              }}
                              // required
                            >
                              <option value="">Select Brand</option>
                              {brand.map((brand) => (
                                <option key={brand.brand_id} value={brand.brand_id}>
                                  {brand.brand_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-4 col-sm-6 mb-4">
                            <label className="form-label-title">Unit Name</label>
                            <select
                              className="form-control"
                              name="unit_id"
                              value={selectedunit} // Ensure correct binding
                              onChange={(e) => {
                                const selectedId = e.target.value;

                                // Find the supplier object using supplier_id
                                const selectedUnit = unit.find((unit) => String(unit.unit_id) === String(selectedId));

                                if (selectedUnit) {
                                  setSelectedUnit(selectedUnit.unit_id); // ✅ Store correct supplier_id
                                  setProducts((prev) => ({
                                    ...prev,
                                    unit_id: selectedUnit.unit_id, // ✅ Ensure supplier_id is stored correctly
                                    unit_name: selectedUnit.unit_name, // ✅ Dynamically store supplier_name
                                  }));
                                }
                              }}
                              // required
                            >
                              <option value="">Select Unit</option>
                              {unit.map((unit) => (
                                <option key={unit.unit_id} value={unit.unit_id}>
                                  {unit.unit_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          
                        </div>
                        <div className="row">
                          {/* Model */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Model</label>
                              <input
                                // required
                                className="form-control"
                                type="text"
                                name="model"
                                placeholder="Enter Model"
                                value={products.model || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          {/* Type */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Type</label>
                              <input
                                // required
                                className="form-control"
                                type="text"
                                name="type"
                                placeholder="Enter Type"
                                value={products.type || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          {/* HSN */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>HSN Code</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="hsn_code"
                                placeholder="Enter HSN Code"
                                value={products.hsn_code || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                        </div>
                        <div className="row">
                         

                          {/* Purchase Rate */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Purchase Rate</label>
                              <input
                                // required
                                className="form-control"
                                type="text"
                                name="purchase_rate"
                                placeholder="Enter Purchase Rate"
                                value={products.purchase_rate || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>

                          {/* Sell Rate */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Sell Rate</label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                name="sell_rate"
                                placeholder="Enter Sell Rate"
                                value={products.sell_rate || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          {/* Stock */}
                          <div className="col-md-4">
                            <div className="mb-4">
                              <label>Stock</label>
                              <input
                                // required
                                className="form-control"
                                type="text"
                                name="stock"
                                placeholder="Enter Stock"
                                value={products.stock || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Submit and Cancel Buttons */}
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-primary me-3" type="submit">
                            Submit
                          </button>
                          <button
                            className="btn btn-outline"
                            type="button"
                            onClick={() => window.history.back()}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProducts;
